import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UsuarioService {


  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('ET_EMYRtokenApi')}`
  });
  constructor(private http: HttpClient) {
  }
  generarPDF(html: string, title: string, state: string, score: string) {
    let watermark = true;
    if (state == "Finalizado") {
      watermark = false
    }
    let datos = {
      "html": `${html}`,
      "type": `${title}`,
      "state": `${state}`,
      "score": `${score}`,
      "watermark": `${watermark}`
    }

    return this.http.post(environment.urlBack + '/pdf/get.html', datos, { reportProgress: true, responseType: 'blob' as 'blob', observe: 'response', headers: this.headers }).pipe(tap(
      (res: any) => {
        return res;
      }));

  }
  finish(id: string) {

    return this.http.post(`${environment.urlBack}/finish?id=${id} `, {}, { headers: this.headers }).pipe(
      map((isAlive: any) => {
        return isAlive;
      })
    );
  }

  getLogs(data) {

    return this.http.post(environment.urlBack + '/logs', data, { responseType: 'blob' as 'blob', headers: this.headers }).pipe(tap(
      (res: any) => {
        return res;
      }));

  }
  setData(data: any) {
    localStorage.setItem('ET_EMYRusername', data.userName)
    localStorage.setItem('ET_EMYRroles', JSON.stringify(data.userInfoDTOs))
  }

  getUsername() {
    return localStorage.getItem('ET_EMYRusername');
  }
  setUserCategories(data: any) {
    localStorage.setItem('ET_EMYRuserCategories', JSON.stringify(data.user.categories))
  }

  getUserCategories() {
    return localStorage.getItem('ET_EMYRuserCategories');
  }
  setgetTokenApi(token: string) {
    localStorage.setItem('ET_EMYRtoken', token)
  }

  setTokenApi(token: string) {
    localStorage.setItem('ET_EMYRtokenApi', token)
  }
  isLoggedIn() {
    return localStorage.getItem('ET_EMYRtokenApi');
  }

  clear() {
    localStorage.clear();
  }

  getRoles() {
    
    let info = JSON.parse(localStorage.getItem('ET_EMYRroles'))

    let array = [];
    if (info) {
      info.forEach(i => {
        array.push(i.puesto?.toUpperCase());
      })
    }

    return array;
  }
  getSections() {
    let info = JSON.parse(localStorage.getItem('ET_EMYRroles'))
    let array: string[] = [];
    const seccionesUnicas = new Set<string>();

    if (info) {
      info.forEach(i => {
        const seccion = i.seccion;
        if (seccion && !seccionesUnicas.has(seccion)) {
          seccionesUnicas.add(seccion);
          array.push(seccion);
        }
      });
    }

    return array;
  }
  getgetTokenApi() {
    return localStorage.getItem('ET_EMYRtoken');
  }
  hasRole() {
    let roles = this.getRoles();
    if (roles && (roles.includes('EJECUTOR') || roles.includes('JEFE DE SECCIÓN') || roles.includes('ANALISTA DE MANTENIMIENTO'))
    ) {
      return true;
    }
    return false;
  }
  isRoles(options) {
    const roles = this.getRoles();
    let found = false;
    roles.forEach(role => {
      if (options.includes(role)) {
        found = true;
      }
    });
    return found;
  }
}







